import { render, staticRenderFns } from "./ProjectEditPage.vue?vue&type=template&id=0b138ea6&scoped=true&"
import script from "./ProjectEditPage.vue?vue&type=script&lang=js&"
export * from "./ProjectEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditPage.vue?vue&type=style&index=0&id=0b138ea6&lang=scss&scoped=true&"
import style1 from "./ProjectEditPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b138ea6",
  null
  
)

export default component.exports